import {ApplicantPhysicalAddressComponentsInput} from './types.mobile.generated'

export * from './types.mobile.generated'

// TODO: Remove and refactor away from this (last step)
export type AddressFormData = ApplicantPhysicalAddressComponentsInput
